import { PaletteMode } from '@mui/material';
import { defaultMode } from '../theme';

const restoreColorMode = (): PaletteMode | null => {
  let mode: PaletteMode | null = null;
  try {
    const storedMode: string | null = window.localStorage.getItem('colorMode');
    if (storedMode && (storedMode === 'dark' || storedMode === 'light')) {
      mode = storedMode;
    } else {
      mode = defaultMode;
    }
  } catch (err) {
    console.error(
      'Ocurrió un error al setear el tipo de tema de la app\n',
      err
    );
  }
  return mode;
};

export default restoreColorMode;
